import type { ReactNode } from 'react'
import { TermsAcceptanceModal } from '@/components/TermsAcceptanceModal/TermsAcceptanceModal'
import { useTermsAcceptance } from '@/hooks/useTermsAcceptance'

interface TermsAcceptanceGateProps {
  children: ReactNode
}

export function TermsAcceptanceGate({ children }: TermsAcceptanceGateProps) {
  const termsState = useTermsAcceptance()

  return (
    <>
      {children}
      {termsState.needsAcceptance && <TermsAcceptanceModal {...termsState} />}
    </>
  )
}
